document.addEventListener("DOMContentLoaded",()=>{

const tabs=document.querySelectorAll(".collection-tab");

const panels=document.querySelectorAll(".collection-panel");

tabs.forEach(tab=>{

tab.addEventListener("click",()=>{

tabs.forEach(t=>t.classList.remove("active"));

tab.classList.add("active");

const handle=tab.dataset.tab;

const viewAll = document.getElementById("collection-view-all");

if (viewAll) {

    const panel = document.querySelector(
        `.collection-panel[data-collection="${handle}"]`
    );

    if (panel) {
        viewAll.href = "/collections/" + handle;
    }

}

panels.forEach(panel=>{

panel.classList.toggle(

"active",

panel.dataset.collection===handle

);

});

});

});

});
const activeTab = document.querySelector(".collection-tab.active");

if (activeTab) {
    activeTab.click();
}